<template>
  <div v-loading="loading">
    <el-form ref="formModel" inline :model="form_model" :rules="rules" label-width="160px" class="track_form">
      <el-row>
        <el-col :span="24">
          <!-- 投放账号以及应用 -->
          <el-form-item label="投放账号以及应用" required>
            <el-form-item prop="advertiser_id">
              <el-select
                v-model="form_model.advertiser_id"
                v-loading="advertiser.loading"
                placeholder="请选择广告投放账号"
                size="mini"
                filterable
                @change="changeAdvertiser"
              >
                <el-option
                  v-for="advertiser_item in advertiser.response"
                  :key="advertiser_item.id"
                  :label="advertiser_item.note"
                  :value="advertiser_item.id"
                >
                  {{ advertiser_item.label }}
                  <span style="color:darkgray">{{ advertiser_item.note }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="package_id">
              <!-- 应用id -->
              <el-select
                v-model="form_model.package_id"
                v-loading="app.loading"
                class="extension_select"
                placeholder="请选择应用"
                size="mini"
                filterable
              >
                <div class="app_title">
                  <span style="float: left">应用名称</span>
                  <span style="float: right">应用id</span>
                </div>
                <el-option
                  v-for="(item, index) in app.response.list"
                  :key="index"
                  :label="item.name"
                  :value="item.type_id"
                >
                  <span style="float: left">{{ item.name }}</span>
                  <span style="float: right">{{ item.type_id }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col class="textarea">
          <el-form-item style="width: 100%;" prop="extend_packages_origin_text">
            <div style="padding: 0 0 20px 30px">
              <el-input
                v-model="form_model.extend_packages_origin_text"
                type="textarea"
                :autosize="{ minRows: 8 }"
                placeholder="请用以下格式批量填写渠道包信息（英文逗号分隔渠道包名称与渠道包标识。换行为一组数据）：
渠道包名称1, 渠道包标识1（渠道包标识用于归因上报，仅支持英文、数字与 - _ .）
渠道包名称2, 渠道包标识2（渠道包标识用于归因上报，仅支持英文、数字与 - _ .）"
                clearable
                size="mini"
              />
              <el-row>
                <el-col style="margin: 15px 0">
                  <el-alert
                    type="info"
                    show-icon
                    :closable="false"
                  >
                    <div>
                      <div>请用以下格式批量填写渠道包信息（英文逗号分隔渠道包名称与渠道包标识）。<b style="color:red">换行为一组数据</b>）：</div>
                      <div>渠道包名称1, 渠道包标识1</div>
                      <div>渠道包名称2, 渠道包标识2</div>
                      <div>输入字符必须符合要求才可分包成功：</div>
                      <div>输入字符不能包含下列任何字符： &lt; &gt; & , 、 \ ' " /</div>
                      <div>渠道标识仅支持英文、数字、三个字符（ - _ . )，广告主可自行上报渠道标识至AMS平台进行归因统计</div>
                    </div>
                  </el-alert>
                </el-col>
              </el-row>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div style="padding: 0 0 20px 30px">
            <el-checkbox v-model="form_model.checked">添加批量创建</el-checkbox>
          </div>
        </el-col>
      </el-row>
      <div v-if="form_model.checked">
        <el-row>
          <el-col :span="8">
            <el-form-item label="渠道包名称前序" prop="batch_extend_packages.channel_name_info.prefix">
              <el-input
                v-model="form_model.batch_extend_packages.channel_name_info.prefix"
                placeholder="渠道包名称前序"
                clearable
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item required>
              <el-form-item label="渠道包名称后续区间" prop="batch_extend_packages.channel_name_info.first">
                <el-input
                  v-model.number="form_model.batch_extend_packages.channel_name_info.first"
                  placeholder="渠道包名称后续区间 ，开始"
                  clearable
                  size="mini"
                />
              </el-form-item>
              <span style="margin: 0 15px;">-</span>
              <el-form-item prop="batch_extend_packages.channel_name_info.last">
                <el-input
                  v-model.number="form_model.batch_extend_packages.channel_name_info.last"
                  placeholder="渠道包名称后续区间，结束"
                  clearable
                  size="mini"
                />
              </el-form-item>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="渠道包标识前序" prop="batch_extend_packages.channel_id_info.prefix">
              <el-input
                v-model="form_model.batch_extend_packages.channel_id_info.prefix"
                placeholder="渠道包标识前序"
                clearable
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item required>
              <el-form-item label="渠道包标识后续区间" prop="batch_extend_packages.channel_id_info.first">
                <el-input
                  v-model.number="form_model.batch_extend_packages.channel_id_info.first"
                  placeholder="渠道包标识后续区间，开始"
                  clearable
                  size="mini"
                />
              </el-form-item>
              <span style="margin: 0 15px;">-</span>
              <el-form-item prop="batch_extend_packages.channel_id_info.last">
                <el-input
                  v-model.number="form_model.batch_extend_packages.channel_id_info.last"
                  placeholder="渠道包标识后续区间，结束"
                  clearable
                  size="mini"
                />
              </el-form-item>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="margin: 30px 0">
            <el-alert
              title="渠道名称后续区间必须和渠道标识后续区间的数量一致，否则不能创建"
              type="info"
              center
              show-icon
              :closable="false"
            />
          </el-col>
        </el-row>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="closeAddDialog">取 消</el-button>
      <el-button size="mini" :loading="submit_loading" type="primary" @click="configAddDialog ">创建应用分包</el-button>
    </span>
  </div>
</template>
<script>
import ExtendPackageResource from '@/api/tool/extend-package/gdt';
const extendPackageResource = new ExtendPackageResource();

import PromotedObject from '@/api/tool/promoted-object/gdt';
const promotedObject = new PromotedObject();

import ConfigResource from '@/api/config';
const configResource = new ConfigResource();

export default {
  data() {
    return {
      submit_loading: false,
      loading: false,
      /** 表单model */
      form_model: {
        extend_packages_origin_text: '',
        advertiser_id: null,
        package_id: null,
        extend_packages: [],
        batch_extend_packages: {
          channel_name_info: {
            prefix: '',
            first: undefined,
            last: undefined,
          },
          channel_id_info: {
            prefix: '',
            first: undefined,
            last: undefined,
          },
        },
      },
      rules: {
        advertiser_id: [
          { required: true, message: '请选择广告主', trigger: ['blur', 'change'] },
        ],
        package_id: [
          { required: true, message: '请选择应用', trigger: ['blur', 'change'] },
        ],
        'batch_extend_packages.channel_name_info.prefix': [
          { required: true, message: '必填', trigger: ['blur', 'change'] },
        ],
        'batch_extend_packages.channel_name_info.first': [
          { required: true, message: '必填', trigger: ['blur', 'change'] },
          { type: 'number', message: '必须为数字值', trigger: ['blur', 'change'] },
        ],
        'batch_extend_packages.channel_name_info.last': [
          { required: true, message: '必填', trigger: ['blur', 'change'] },
          { type: 'number', message: '必须为数字值', trigger: ['blur', 'change'] },
        ],
        'batch_extend_packages.channel_id_info.prefix': [
          { required: true, message: '必填', trigger: ['blur', 'change'] },
        ],
        'batch_extend_packages.channel_id_info.first': [
          { required: true, message: '必填', trigger: ['blur', 'change'] },
          { type: 'number', message: '必须为数字值', trigger: ['blur', 'change'] },
        ],
        'batch_extend_packages.channel_id_info.last': [
          { required: true, message: '必填', trigger: ['blur', 'change'] },
          { type: 'number', message: '必须为数字值', trigger: ['blur', 'change'] },
        ],
      },
      /** 应用ID */
      app: {
        loading: false,
        params: { is_list: 1, advertiser_id: '', promoted_object_type: 'PROMOTED_OBJECT_TYPE_APP_ANDROID' },
        response: { list: [] },
      },
      /** 广告主id */
      advertiser: {
        loading: false,
        params: {
          module: 'ad',
          key: 'gdt_pack_account',
        },
        response: [],
      },
    };
  },
  created() {
    /** 获取广告主 */
    this.getConfigList().then((response) => {
      this.advertiser.response = response;
    });
  },
  methods: {
    /** 获取应用列表 */
    getAppList() {
      this.app.loading = true;
      promotedObject
        .getPromotedObject(this.app.params)
        .then((response) => {
          this.app.response = response;
        }).finally(() => {
          this.app.loading = false;
        });
    },

    /** 切换广告主 */
    changeAdvertiser(val){
      this.form_model.package_id = null;
      this.form_model.advertiser_id = val;
      this.app.params.advertiser_id = val;
      this.getAppList();
    },

    /** 获取广告配置列表 */
    getConfigList: function() {
      this.advertiser.loading = true;
      return new Promise((resolve, reject) => {
        configResource
          .getConfigDataApi(this.advertiser.params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => {
            this.advertiser.loading = false;
          });
      });
    },

    /** 确定创建应用分包 */
    configAddDialog(){
      this.$refs['formModel'].validate((valid) => {
        if (valid) {
          this.submit_loading = true;
          const { advertiser_id, package_id, batch_extend_packages, extend_packages_origin_text, checked } = this.form_model;
          const extend_packages = extend_packages_origin_text.split(/[(\r\n)\r\n]+/).filter(item => item).map(pack => {
            const temp = pack.split(',');
            return { channel_name: temp[0], channel_id: temp[1] };
          });
          const positionData = {
            advertiser_id,
            package_id,
            extend_packages,
            batch_extend_packages,
          };
          if (!checked) {
            delete positionData.batch_extend_packages;
          }
          extendPackageResource.createExtendPackageApi(positionData).then((res) => {
            this.$emit('config', res);
          }).finally(() => {
            this.submit_loading = false;
          });
        } else {
          return false;
        }
      });
    },

    /** 取消创建 */
    closeAddDialog(){
      this.$emit('cancel');
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.textarea /deep/ .el-form-item__content {
  width: 100%;
}

.el-card /deep/ .el-card__header{
   padding: 2px 20px;
}
.input_class{
  width: 300px;
}
.dialog-footer{
  width: 100%;
  text-align: center;
  display: block;
}
.box-card {
  width: 300px;
}
.channels_tags{
  margin-left: 10px;
}

.extension_select{
  width: 350px;
}

.app_title{
  width: 100%;
  height: 23px;
  float: left;
  line-height: 22px;
  padding-left: 20px;
  border-bottom: 1px solid gray;
  padding-right: 20px;
  span{
    font-size: 14px;
    font-weight: 700;
  }
}
</style>
